import { render, staticRenderFns } from "./Detail-Template.vue?vue&type=template&id=90ba0de2&scoped=true"
import script from "./Detail-Template.vue?vue&type=script&lang=js"
export * from "./Detail-Template.vue?vue&type=script&lang=js"
import style0 from "./Detail-Template.vue?vue&type=style&index=0&id=90ba0de2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90ba0de2",
  null
  
)

export default component.exports